import React from 'react';
import { Button, ConfigProvider } from 'antd-v5';
import GenAICircleIcon from 'assets/svg/GenAICircleAlt';

interface CustomButtonProps {
    onClick?: () => void;
    children?: React.ReactNode;
    disabled?: boolean;
    className?: string;
}

const CustomAsperButton: React.FC<CustomButtonProps> = ({
    onClick,
    children = 'AskAsper',
    disabled = false,
    className = '',
}) => {
    return (
        // Self-scope to the ant5 prefix so this button (rendered in the navbar,
        // outside the AskAsper route's ConfigProvider) does not collide with antd 4.
        <ConfigProvider prefixCls="ant5" iconPrefixCls="ant5icon">
            <Button
                onClick={onClick}
                disabled={disabled}
                className={`ask-asper-button ${className}`}
                style={{
                    background: 'linear-gradient(80deg, #ff6699 -10.59%, #5F49BC 55.76%)',
                    border: 'none',
                    borderRadius: '6px',
                    height: '32px',
                    padding: '0 12px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    boxShadow: '0 2px 2px 0 #5f49bc1a, 0 0 0 1px rgba(95, 73, 188, 0.10)',
                    color: 'white',
                    fontSize: '14px',
                    fontWeight: '500',
                    transition: 'all 0.3s ease',
                }}
            >
                <GenAICircleIcon />
                {children}
            </Button>
        </ConfigProvider>
    );
};

export default CustomAsperButton;
